import { actions as accountActions } from '@app/store/action/account';
import Transform from '@app/transformers';

export default function (state = {}, action) {
  const { type } = action;

  switch (type) {
    case accountActions.ACCOUNT_UPDATE_SUCCESS: {
      const account = Transform.account(action.details);
      return {
        ...state,
        defaultRecipient: account.default_recipient_email,
        defaultRecipientVerified: account.receiving_email_confirmed,
      };
    }
  }

  if (typeof state.defaultRecipientVerified !== 'boolean') {
    return {
      ...state,
      // force defaultRecipientVerified to a boolean
      defaultRecipientVerified: !!state.defaultRecipientVerified,
    };
  }

  return state;
}
